import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTraffic = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 22,
	height: 20,
	fill: "none",
	viewBox: "0 0 22 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M0 10.588V8.235h3.53v2.353H0Zm4 6.53-1.647-1.706 2.47-2.47 1.706 1.646L4 17.118Zm.824-11.236-2.471-2.47L4 1.706l2.53 2.53-1.706 1.646Zm14 14.118-5.589-5.588-1.47 4.411L8.235 7.06 20 10.589l-4.353 1.529 5.53 5.53L18.823 20ZM9.411 3.53V0h2.353v3.53H9.412Zm6.94 2.352-1.705-1.647 2.53-2.53 1.646 1.648-2.47 2.53Z" })
});
export { SvgTraffic as ReactComponent };
